export default {
  title: "Canal Aceptación"
  , form: {
    descripcion: {
      label: "Descripción"
      , th: "Descripción"
    }
  }
  , errors: {
    BD5023: { text: "Ocurrió un error en el catálogo de Canal Aceptación" }
    , WS5023: { text: "Ocurrió un error en el catálogo de Canal Aceptación" }
    , JS5023: { text: "Ocurrió un error en el catálogo de Canal Aceptación" }
    , CR5023: { text: "Ocurrió un error en el catálogo de Canal Aceptación" }
    , UK_CanalAceptacion: { text: "No se puede agregar un registro con una descripción ya existente" }
  }
};



// WEBPACK FOOTER //
// ./src/locales/languages/es_MX/view/operativos/canalaceptacion.js